<script>

export default {
  props: {
    data:{
      type: Object
    },
  },
  data() {
    return {
      // male & female
      totalParticipants: this.data.gender.totalParticipants,
      maleParticipants: this.data.gender.maleParticipants,
      femaleParticipants: this.data.gender.femaleParticipants,
      // Artwork
      totalArtwork: this.data.main.totalArtwork,
      literatureTexts: this.data.main.literatureTexts,
      arts: this.data.main.arts,
      media: this.data.main.media,
    };
  },
  computed:{
    // male & female
    malePercentage() {
      return (this.maleParticipants / this.totalParticipants) * 100;
    },
    femalePercentage() {
      return (this.femaleParticipants / this.totalParticipants) * 100;
    },
    // Artwork
    literatureTextsPercentage() {
      return (this.literatureTexts / this.totalArtwork) * 100;
    },
    artsPercentage() {
      return (this.arts / this.totalArtwork) * 100;
    },
    mediaPercentage() {
      return (this.media / this.totalArtwork) * 100;
    },
  },
  methods: {},
  created(){},
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs me-3">
                <img class="ms-2" height="40px" src="@/assets/images/logo2.png" alt="image" />
              </div>
              <h5 class="font-size-18 mt-2 mb-0">مهرجان قادة النصر الاول</h5>
            </div>
            <div class="text-muted mt-4">
              <h5> عدد المشاركين الكلي </h5>
              <div class="d-flex">
                <h5>98</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs me-3">
                <img class="ms-2" height="40px" src="@/assets/images/logo2.png" alt="image" />
              </div>
              <h5 class="font-size-18 mt-2 mb-0">مهرجان قادة النصر الثاني</h5>
            </div>
            <div class="text-muted mt-4">
              <h5> عدد المشاركين الكلي </h5>
              <div class="d-flex">
                <h5>212</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs me-3">
                <img class="ms-2" height="40px" src="@/assets/images/logo2.png" alt="image" />
              </div>
              <h5 class="font-size-18 mt-2 mb-0">مهرجان قادة النصر الثالث</h5>
            </div>
            <div class="text-muted mt-4">
              <h5> عدد المشاركين الكلي </h5>
              <div class="d-flex">
                <h5>315</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs me-3">
                <img class="ms-2" height="40px" src="@/assets/images/logo2.png" alt="image" />
              </div>
              <h5 class="font-size-18 mt-2 mb-0">مهرجان قادة النصر الرابع</h5>
            </div>
            <div class="text-muted mt-4">
              <h5> عدد المشاركين الكلي </h5>
              <div class="d-flex">
                <h5>645</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 col-sm-12">
        <div class="card" style="height: calc(100% - 24px);">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-2">
                <h4 class="card-title mb-3">اعداد المشاركين</h4>
              </div>
              <div class="avatar-sm ms-auto">
                <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                  <i class="bx bxs-user"></i>
                </div>
              </div>
            </div>
            <div class="row text-center">
              <div class="col-12">
                <div class="mt-3">
                  <h4 class="mb-1">العدد الكلي</h4>
                  <h5>{{ totalParticipants }}</h5>
                </div>
              </div>
            </div>
            <hr />
            <div>
              <ul class="list-group list-group-flush">
                <li class="list-group-item">
                  <div class="py-2">
                    <h5 class="font-size-14">
                      الذكور <span class="float-end">{{ maleParticipants }}</span>
                    </h5>
                    <div class="progress animated-progess progress-sm">
                      <div
                        class="progress-bar"
                        role="progressbar"
                        :style="{ width: malePercentage + '%' }"
                        :aria-valuenow="malePercentage"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                </li>
                <li class="list-group-item">
                  <div class="py-2">
                    <h5 class="font-size-14">
                      الاناث <span class="float-end">{{ femaleParticipants }}</span>
                    </h5>
                    <div class="progress animated-progess progress-sm">
                      <div
                        class="progress-bar bg-success"
                        role="progressbar"
                        :style="{ width: femalePercentage + '%' }"
                        :aria-valuenow="femalePercentage"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-2">
                <h4 class="card-title mb-3">عدد الاعمال</h4>
              </div>
              <div class="avatar-sm ms-auto">
                <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                  <i class="bx bx-image"></i>
                </div>
              </div>
            </div>
            <div class="row text-center">
              <div class="col-12">
                <div class="mt-3">
                  <h4 class="mb-1">العدد الكلي</h4>
                  <h5>{{ totalArtwork }}</h5>
                </div>
              </div>
            </div>
            <hr />
            <div>
              <ul class="list-group list-group-flush">
                <li class="list-group-item">
                  <div class="py-2">
                    <h5 class="font-size-14">
                      الادب والنصوص <span class="float-end">{{ literatureTexts }}</span>
                    </h5>
                    <div class="progress animated-progess progress-sm">
                      <div
                        class="progress-bar"
                        role="progressbar"
                        :style="{ width: literatureTextsPercentage + '%' }"
                        :aria-valuenow="literatureTextsPercentage"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                </li>
                <li class="list-group-item">
                  <div class="py-2">
                    <h5 class="font-size-14">
                      الفنون <span class="float-end">{{ arts }}</span>
                    </h5>
                    <div class="progress animated-progess progress-sm">
                      <div
                        class="progress-bar bg-success"
                        role="progressbar"
                        :style="{ width: artsPercentage + '%' }"
                        :aria-valuenow="artsPercentage"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                </li>
                <li class="list-group-item">
                  <div class="py-2">
                    <h5 class="font-size-14">
                      وسائل الاعلام <span class="float-end">{{ media }}</span>
                    </h5>
                    <div class="progress animated-progess progress-sm">
                      <div
                        class="progress-bar bg-warning"
                        role="progressbar"
                        :style="{ width: mediaPercentage + '%' }"
                        :aria-valuenow="mediaPercentage"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>